const RewindText = () => {
    return (
        <div className="LockedChoices">
            <h1>CHOICES LOCKED</h1>
        </div>
    )
}

export default RewindText;